import { handleActions } from "redux-actions";
import {
    getInitialScrapeTaskBatchStarts,
    getInitialScrapeTaskBatchStartsSuccess,
    getInitialScrapeTaskBatchStartsError,
    clearInitialScrapeTaskBatchStarts,
    mergeInitialScrapeTaskBatchStartDialog,
    setInitialScrapeTaskBatchStartDialog,
    mergeDownloadResultObjectsDialog,
    setDownloadResultObjectsDialog,
    setDetailedProgressInfo
} from "modules/InitialScrapeTaskBatchStarts/services/InitialScrapeTaskBatchStarts/actions";

const initialState = {
    isLoading: false,
    ids: [],
    initialScrapeTaskBatchStarts: [],
    count: 0,
    progressInfo: {},
    initialScrapeTaskBatchStartDialog: {
        isOpen: false,
        isLoading: false
    },
    downloadDialog: {
        isOpen: false,
        isLoading: false,
        status: null,
        url: null
    },
};

export const initialScrapeTaskBatchStartsEntriesReducer = handleActions(
    {
        [clearInitialScrapeTaskBatchStarts]: () => ({ ...initialState }),
        [getInitialScrapeTaskBatchStarts]: (state) => ({
            ...state,
            ids: [],
            initialScrapeTaskBatchStarts: [],
            count: 0,
            isLoading: true
        }),
        [getInitialScrapeTaskBatchStartsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getInitialScrapeTaskBatchStartsError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setInitialScrapeTaskBatchStartDialog]: (state, { payload }) => ({
            ...state,
            initialScrapeTaskBatchStartDialog: {
                ...initialState.initialScrapeTaskBatchStartDialog,
                ...payload
            }
        }),
        [mergeInitialScrapeTaskBatchStartDialog]: (state, { payload }) => ({
            ...state,
            initialScrapeTaskBatchStartDialog: {
                ...state.initialScrapeTaskBatchStartDialog,
                ...payload
            }
        }),

        [setDownloadResultObjectsDialog]: (state, { payload }) => ({
            ...state,
            downloadDialog: {
                ...initialState.downloadDialog,
                ...payload
            }
        }),
        [mergeDownloadResultObjectsDialog]: (state, { payload }) => ({
            ...state,
            downloadDialog: {
                ...state.downloadDialog,
                ...payload
            }
        }),

        [setDetailedProgressInfo]: (state, { payload }) => ({
            ...state,
            progressInfo: {
                ...state.progressInfo,
                ...payload
            }
        }),
    },
    initialState
);
